import { InsuranceCarrier, insuranceCarrierDefs } from '@shared';

export function getCarrierImage(
  carrierId?: number,
): { src: string; size: string } | undefined {
  if (
    carrierId !== undefined &&
    insuranceCarrierDefs[carrierId as InsuranceCarrier]?.image
  ) {
    return insuranceCarrierDefs[carrierId as InsuranceCarrier].image;
  }
  return undefined;
}
